import moment from "moment";

// init function uses the resolved promises from all our api requests to build up a single object, so we only call setState once when the component mounts
export const onSubmit = async (
  props,
  handleAlertModal,
  values,
  customFields
) => {
  const { apiUrl, facilities, userId, token } = props;
  const {
    assetTag,
    category,
    description,
    note,
    quantity,
    selectedAssetClassifications,
    selectedFacility,
    selectedZone,
    status,
    timeNeeded,
    timeCreatedUser,
    xCoordinate,
    yCoordinate,
  } = values;

  const facility = facilities[selectedFacility.value] || {};
  const { location = {}, name: facilityName } = facility;
  const { facilityId, latitude, longitude } = location;

  const body = {
    assetMode: "Asset",
    category: category.value,
    customMap: {},
    classificationMap: selectedAssetClassifications,
    location,
    timeNeeded: timeNeeded?.value
      ? moment(timeNeeded.value, "MM/DD/yyyy").format("YYYYMMDDHHmm")
      : "",
    timeCreatedUser: timeCreatedUser?.value
      ? moment(timeCreatedUser.value, "MM/DD/yyyy").format("YYYYMMDDHHmm")
      : "",
    facility: facilityName,
    facilityId,
    propertiesMap: {
      category: category.value,
      description: description.value,
      assetDetails: note.value,
    },
    quantity,
    tag: assetTag.value,
  };

  // Only send zone / xyz when the user actually provided them
  if (selectedZone?.value) {
    body.zone = { zoneId: selectedZone.value };
  }
  if (xCoordinate?.value !== "" && yCoordinate?.value !== "") {
    body.xyz = {
      x: xCoordinate.value,
      y: yCoordinate.value,
    };
  }

  Object.keys(customFields).forEach((field) => {
    const { name, value = "" } = customFields[field];
    if (
      value?.length > 0 ||
      typeof value === "number" ||
      value instanceof Date
    ) {
      body.customMap[name] = value;
    }
  });

  try {
    const createRes = await fetch(`${apiUrl}assets/`, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        "auth-token": token,
      },
      body: JSON.stringify(body),
    });
    const createJson = await createRes.json();

    if (createJson.error || createJson.success === false) {
      return createJson;
    }

    const assetId = createJson?.asset?.assetId;
    if (!assetId) {
      return {
        success: false,
        error: "Create asset succeeded but no assetId was returned",
        errors: ["Create asset succeeded but no assetId was returned"],
      };
    }

    const updateAssetBody = {
      action: status.value,
      appUserId: userId,
      facilityId,
      facility: facilityName,
      latitude,
      longitude,
    };
    if (selectedZone?.value) {
      updateAssetBody.zone = { zoneId: selectedZone.value };
    }

    const actionRes = await fetch(`${apiUrl}assets/${assetId}/action`, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        "auth-token": token,
      },
      body: JSON.stringify(updateAssetBody),
    });
    const actionJson = await actionRes.json();

    // Action failed (e.g. asset not found because create never persisted)
    if (actionJson.error || actionJson.success === false) {
      handleAlertModal({
        modalText:
          actionJson.errors?.[0] ||
          actionJson.error ||
          "Asset was created but applying the status action failed",
        alertModalColor: "error",
      });
      return actionJson;
    }

    handleAlertModal({
      modalText: "Asset Successfully Added",
      alertModalColor: "success",
    });
    return createJson.asset;
  } catch (error) {
    handleAlertModal({
      modalText: error.toString(),
      alertModalColor: "error",
    });
    return {
      success: false,
      error: error.toString(),
      errors: [error.toString()],
    };
  }
};
